<template>
  <router-link
    class="link"
    :to="{
      name: 'instruction',
      params: instructionRouteParams
    }">
    <slot />
  </router-link>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        required: true
      }
    },

    computed: {
      instructionRouteParams() {
        return this.$store.getters.getInstructionRoute(this.name)
      }
    }
  }
</script>